var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnnual = function SvgAnnual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M28.664 6.564H15.828M48.868 6.564h-13.06M68.516 6.564H55.792M84.256 64.496V12.568c0-3.314-2.686-6-6-6h-2.7M8.908 6.564h-2.7c-3.314 0-6 2.686-6 6v60c0 3.314 2.686 6 6 6H63.92"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 28.776,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 28.776,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 28.776,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 64.908,
    y: 28.776,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 45.296,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 45.296,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 45.296,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 64.908,
    y: 45.296,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 61.932,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 61.932,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 61.932,
    fill: "#89B6DE",
    fillRule: "nonzero",
    rx: 1.184
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M77.112 21.588h7.144M66.508 21.588h5.024M11.476 21.588h49.116M.424 21.588h5.468"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 9.296,
    y: 0.2,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 29.132,
    y: 0.2,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 48.964,
    y: 0.2,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 68.796,
    y: 0.2,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.928,
    cy: 74.496,
    r: 12.34,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M70.952 75.66L74.304 79.232 81.892 71.528"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnnual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/annual.c7c356de.svg";
export { ForwardRef as ReactComponent };